import { render } from "./RssPage.vue?vue&type=template&id=45ec42c4&scoped=true"
import script from "./RssPage.vue?vue&type=script&lang=js"
export * from "./RssPage.vue?vue&type=script&lang=js"

import "./RssPage.vue?vue&type=style&index=0&id=45ec42c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ec42c4"]])

export default __exports__